import { useQuery } from "@tanstack/react-query"
import { PrognosisInfo } from "core/models/jianDetail/prognosisInfo"
import { apiClient } from "core/utils/apiClient"

/** 予後入力データを取得するカスタムフック */
export const usePrognosis = (hospitalId?: string | null, patientId?: string | null) => {
    const {data: prognosisInfo, isLoading, isError} = useQuery({
        queryKey: ['prognosis', hospitalId, patientId],
        queryFn: async () => apiClient.get<PrognosisInfo>(`/outcomes/${hospitalId}/${patientId}`)
          .then((res) => fetchResponseToPrognosisInfo(res)),
        enabled: !!(hospitalId && patientId)
    });

    return {prognosisInfo, isLoading, isError}
}

/** APIのレスポンスを予後入力情報に変換する関数 */
const fetchResponseToPrognosisInfo = (response: any): PrognosisInfo => {
    return response?.data?.confirmed_diagnosis
}